import {action, makeAutoObservable, runInAction} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import Pagination from "../../../entities/Pagination";
import TransactionStatus from "../../../entities/TransactionStatus";
import { AgencyBalanceTransactionService } from "../../../service/AgencyBalanceTransactionService";
import AgencyBalanceTransaction from "../../../entities/AgencyBalanceTransaction";
import { AgencyService } from "../../../service/AgencyService";

class ViewAgencyBalanceTransactionsStore {

    public entityId: string;
    public agencyBalance?: number;
    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;

    public pagination: Pagination;
    public transactions: AgencyBalanceTransaction[];
    public from?: number;
    public to?: number;
    public status?: TransactionStatus;


    constructor(commonStore: CommonStore, entityId: string) {
        this.entityId = entityId;
        this.isModalOpen = false;
        this.loading = false;
        this.commonStore = commonStore;
        this.pagination = new Pagination(1, 10, 0, 0);
        this.transactions = [];
        makeAutoObservable(this);
    }

    @action
    public async searchBalanceTransations(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        this.loading = true;
        const response = await AgencyBalanceTransactionService.get(
            this.entityId,
            page,
            pageSize,
            this.from,
            this.to,
            this.status,
        );
        if (response.success) {
            runInAction(() => {
                this.transactions = response.data?.data || [];
                this.pagination = response.data?.pagination || this.pagination;
            })
        }
        this.commonStore.processErrors(response);
        this.loading = false;
    }

    @action
    public async loadAgencyBalance(): Promise<void> {
        this.loading = true;
        const response = await AgencyService.find(this.entityId);
        if (response.success) {
            runInAction(() => {
                this.agencyBalance = response.data?.balance;
            })
        }
        this.commonStore.processErrors(response);
        this.loading = false;
    }

    @action
    public async openModal() {
        this.isModalOpen = true;
        await this.loadAgencyBalance();
        await this.searchBalanceTransations();
    }

    @action
    public async cleanFilter() {
        this.from = undefined;
        this.to = undefined;
        await this.searchBalanceTransations();
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    get isEmpty(): boolean {
        return this.transactions.length === 0;
    }

    @action
    public async goToPage(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        await this.searchBalanceTransations(page, pageSize);
    }

}

export default ViewAgencyBalanceTransactionsStore;